import { InlineLink, Li, List } from '@collab/atoms';
import { volvoSupportPrivacyLink } from '@collab/utils/externalLinks';

import { CookieSettingsButton } from './Components';

const Introduction = () => (
  <>
    <h1>Your Privacy</h1>

    <p>
      When you visit our web site, we will use cookies to ensure that you get
      the best experience on our website. These cookies might be about you, your
      preferences or your device. The information does not usually directly
      identify you, but it can give you a more personalised web experience.
      Because we respect your right to privacy, you can choose not to allow some
      types of cookies. Click on the different category headings to find out
      more and change our default settings. However, blocking some types of
      cookies may impact your experience of the site and the services we are
      able to offer.
    </p>

    <p>
      We will need to use a cookie to remember the choices that you have made
      within our cookie privacy manager. This will have a couple of
      consequences:
    </p>

    <List as="ul">
      <Li>
        If you delete all your cookies you will have to update your preferences
        with us again.
      </Li>
      <Li>
        If you use a different device or browser you will have to tell us your
        preferences again.
      </Li>
    </List>

    <CookieSettingsButton />

    <h2>Information Notice – www.volvocars.com</h2>

    <h3>Controller</h3>
    <p>
      Volvo Car Corporation, a Swedish legal entity with company registration
      number 556074-3089 with address Assar Gabrielssons Väg, SE-405 31,
      Gothenburg, Sweden, hereinafter referred to as{' '}
      <strong>&quot;Volvo&quot;</strong>,<strong> &quot;we&quot;</strong>,
      <strong> &quot;us&quot;</strong>, will as controller process your personal
      data as further described below.
    </p>

    <h3>Purpose and legal basis for processing</h3>
    <p>
      When you visit our website(s) we collect and process your IP number and
      information on your browsing on our website. The purpose of our processing
      is to identify you as return visitor to our website, to analyse the
      behaviour of the visitors to our website to enhance our communication and
      structure of our website(s) and to build a profile of your interests to be
      able to show you relevant adverts for our products and services also on
      other websites. When possible we also combine your online web behaviour
      data with the personal data that you eventually have previously provided
      to us.
    </p>

    <p>
      The legal basis for our processing of your personal data as described
      above is that this processing is necessary for the purposes of our
      legitimate interest, except for the processing where we combine your
      online web behaviour data with the personal data that you eventually have
      previously provided to us for which we base on your consent. You have the
      right to withdraw your consent at any time which you do by directing a
      request for withdrawal of consent to the Business Management Team. You
      also have the right to decline our use of these cookies by clicking the
      link “change cookie settings” located within the Your Privacy section at
      the top of this page. Select “Advanced Analytics” cookie category and set
      them inactive. Should you wish to contact us about this data or other
      personal data that we might process in relation to you, please refer to
      the “Your rights and contact information” section below.
    </p>

    <p>
      We process your geolocation data to ensure that we can provide you with
      the services or dealership closest to your current location. This
      functionality will be used throughout our website. The consent for this is
      taken through your browser and can be adjusted within the browser
      settings.
    </p>

    <h3>Disclosure / Recipients of your personal data</h3>
    <p>
      Your personal data will be disclosed to and processed by our affiliates
      and business partners for the above purposes.
    </p>

    <h3>Retention time</h3>
    <p>
      We will retain your personal data up to two (2) years after your last
      visit to our website.
    </p>

    <h3>Your rights and contact information</h3>
    <p>
      For more information on your rights in relation to our processing of your
      personal data and contact details for further information and complaints
      as well as contact details to our Data Protection Officer, please visit
      our <InlineLink href={volvoSupportPrivacyLink}>support page</InlineLink>.
    </p>
  </>
);

export default Introduction;
